import { render, staticRenderFns } from "./addVoters.vue?vue&type=template&id=6d15e95b&scoped=true&"
import script from "./addVoters.vue?vue&type=script&lang=js&"
export * from "./addVoters.vue?vue&type=script&lang=js&"
import style0 from "./addVoters.vue?vue&type=style&index=0&id=6d15e95b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d15e95b",
  null
  
)

export default component.exports